import { render } from "./NavMenuItem.vue?vue&type=template&id=23d32834&scoped=true"
import script from "./NavMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./NavMenuItem.vue?vue&type=style&index=0&id=23d32834&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d32834"],['__file',"src/components/app/sidebar/NavMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23d32834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23d32834', __exports__)) {
    api.reload('23d32834', __exports__)
  }
  
  module.hot.accept("./NavMenuItem.vue?vue&type=template&id=23d32834&scoped=true", () => {
    api.rerender('23d32834', render)
  })

}


export default __exports__